<template>
  <v-row dense class="pt-6">
    <v-col cols="12" md="12">
      <v-card
        tile
        flat
        class="userBriefHistory"
        :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'"
      >
        <v-container>
          <v-row dense>
            <!-- Start User Statistics History -->
            <v-col cols="12" sm="6" md="3">
              <v-sheet
                :class="
                  $vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                "
              >
                <v-card-text class="trade">
                  <div class="icon-wrapper">
                    <div class="icon-box">
                      <v-img src="@/assets/Dashboard/balance.png" alt="Referral"></v-img>
                    </div>
                    <div class="icon-content">
                      <h3>Referral</h3>
                      <span>Accounts</span>
                    </div>
                  </div>
                  <p class="amount">{{ affiliateSummary.referralAccounts }}</p>
                </v-card-text>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-sheet
                :class="
                  $vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                "
              >
                <v-card-text class="trade">
                  <div class="icon-wrapper">
                    <div class="icon-box">
                      <v-img src="@/assets/Dashboard/earning.png" alt="Total Deposit"></v-img>
                    </div>
                    <div class="icon-content">
                      <h3>Total Deposit</h3>
                      <span>Of My Clients</span>
                    </div>
                  </div>
                  <p class="amount">${{ affiliateSummary.totalDeposit }}</p>
                </v-card-text>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-sheet
                :class="
                  $vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                "
              >
                <v-card-text class="trade">
                  <div class="icon-wrapper">
                    <div class="icon-box">
                      <v-img src="@/assets/Dashboard/referral.png" alt="Affiliate Balance"></v-img>
                    </div>
                    <div class="icon-content">
                      <h3>Affiliate Balance</h3>
                      <span>/ Total Affi. Earning</span>
                    </div>
                  </div>
                  <p class="amount">${{ affiliateSummary.affiliateBalance }}</p>
                </v-card-text>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-sheet
                :class="
                  $vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                "
              >
                <v-card-text class="trade">
                  <div class="icon-wrapper">
                    <div class="icon-box">
                      <v-img src="@/assets/Dashboard/withdraw.png" alt="Total Level"></v-img>
                    </div>
                    <div class="icon-content">
                      <h3>Total Level</h3>
                      <span>Clients I Have</span>
                    </div>
                  </div>
                  <p class="amount">{{ affiliateSummary.totalLevels }}</p>
                </v-card-text>
              </v-sheet>
            </v-col>
            <!-- Start User Statistics History -->
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADEMASTER__ACTIONS } from "@/store/action-types";

export default {
  computed: {
    ...mapState("tradeMaster", ["affiliateSummary"]),
  },
  methods: {
    ...mapActions("tradeMaster", [TRADEMASTER__ACTIONS.AFFILIATESUMMARY,])
  },
  async mounted() {
    await this[TRADEMASTER__ACTIONS.AFFILIATESUMMARY](this.$route.params.id);
  },
};
</script>
